import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowFitBottomLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.748 21.001A2.75 2.75 0 0 1 3 18.251V8.298a.75.75 0 0 1 1.5 0v9.953q0 .09.012.177L18.442 4.5h-6.158a.75.75 0 0 1 0-1.5h8.717v8.716h-.75.75a.75.75 0 1 1-1.5 0h.75-.75V5.56L5.573 19.489q.086.012.175.012h9.955a.75.75 0 0 1 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomLeft24);
